import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { convertPriorityToBidderTier } from '~/src/dash/api/headerbidders/utils_headerbidder';
import { IFlexibleBiddingThreshold } from '~/src/dash/api/types/flexible_bidding';

interface IFlexibleBiddingDialogProps {
  onRevert: () => void;
  onConfirm: () => void;
  invalidThresholds: IFlexibleBiddingThreshold[];
  open: boolean;
}
export function FlexibleBiddingDialog({
  open,
  onRevert,
  onConfirm,
  invalidThresholds,
}: IFlexibleBiddingDialogProps) {
  return (
    <Dialog open={open} onClose={onRevert} aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>Cleanup Required</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The updated tier setting is greater than or equal to one or more Flexible Bidding rules.
          The impacted rules will be deleted after the change is saved. If there are no more valid
          rules, Flexible Bidding will be deactivated.
        </DialogContentText>
        <ul>
          {invalidThresholds.map((threshold) => (
            <li>Tier {convertPriorityToBidderTier(threshold.BidderPriority.toString())}</li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        {/* Revert Button*/}
        <Button onClick={onRevert} color='secondary'>
          Revert
        </Button>
        {/* Confirm Button*/}
        <Button onClick={onConfirm} color='primary' autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
